import { Box, Grid, Typography } from "@mui/material"
import { useContext, useState } from "react"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { CondominiosContext } from "../../../../Providers/CondominiosContext/CondominiosContext"
import { showNotify } from "../../../../Utils/Utils"
import { VisitantesContext } from "../../../../Providers/VisitantesContext/VisitantesContext"

const Metricas = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { setListaSaida, metricas, setMetricas } = useContext(VisitantesContext)
    const { activeCond } = useContext(CondominiosContext)
    const [tipoVisitanteFiltro, setTipoVisitanteFiltro] = useState('')

    const getListaVisitantesSaida = (msg) => {
        if (msg.data.status) {
            let dados = msg.data.listaSaida
            setListaSaida([...dados.visitantesAutorizados, ...dados.entrouDispositivo])
            setMetricas({
                visitantes: dados.totalMetricas['Visitantes (AppOne)'],
                prest: dados.totalMetricas['Prest. Serviço (AppOne)'],
                hospede: dados.totalMetricas['Hóspede (AppOne)']
            })
        } else {
            showNotify('warning', 'Erro ao listar visitantes')
        }
    }

    const filtrarListaPessoasSaida = (tipo) => {
        if (tipoVisitanteFiltro === tipo) {
            setTipoVisitanteFiltro('')
            addRoute('listaVisitantesSaida', getListaVisitantesSaida)
            sendWs("listaVisitantesSaida", { filtros: { id_central: activeCond.id_central, filtro: '', id_entrada: '', tipo: '' } })
        } else {
            setTipoVisitanteFiltro(tipo)
            addRoute('listaVisitantesSaida', getListaVisitantesSaida)
            sendWs("listaVisitantesSaida", { filtros: { id_central: activeCond.id_central, filtro: '', id_entrada: '', tipo } })
        }
    }

    return (
        <Grid sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            padding: '3px',
            overflowY: 'scroll',
            height: '100%',
            alignItems: 'center'
        }}>
            <Typography variant="h6" sx={{ height: '10%', color: 'black', alignItems: 'center', display: 'flex' }}>Dentro</Typography>
            <Box onClick={() => filtrarListaPessoasSaida('Visitantes (AppOne)')} sx={{ border: tipoVisitanteFiltro == 'Visitantes (AppOne)' ? '3px solid green' : '3px solid #000000', cursor: 'pointer', borderRadius: '10px', width: '80%', height: '27%', alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: ' center', margin: '5%', padding: "3px 0 1px 0" }}>
                <Box sx={{ width: '100%', height: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column', blackSpace: 'nowrap' }}>
                    <Typography sx={{ color: 'black', fontSize: '4.0vh', fontWeight: '600', height: '50%', alignItems: 'end', display: 'flex', justifyContent: 'center' }}>{ metricas.visitantes}</Typography>
                    <Box sx={{ width: '100%', height: '40%', display: 'flex', alignItems: 'center', overflow: 'hidden', justifyContent: 'center' }}>
                        <Typography sx={{ color: 'black', fontSize: '2.0vh', blackSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                            visitantes
                        </Typography>
                    </Box>
                </Box>

            </Box>
            <Box onClick={() => filtrarListaPessoasSaida('Prest. Serviço (AppOne)')} sx={{ border: tipoVisitanteFiltro == 'Prest. Serviço (AppOne)' ? '3px solid green' : '3px solid #000000', cursor: 'pointer', borderRadius: '10px', width: '80%', height: '27%', alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: ' center', margin: '5%', padding: "3px 0 1px 0" }}>
                <Box sx={{ width: '100%', height: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column', blackSpace: 'nowrap' }}>
                    <Typography sx={{ color: 'black', fontSize: '4.0vh', fontWeight: '600', height: '50%', alignItems: 'end', display: 'flex', justifyContent: 'center' }}>{ metricas.prest}</Typography>
                    <Box sx={{ width: '100%', height: '40%', display: 'flex', alignItems: 'center', overflow: 'hidden', justifyContent: 'center' }}>
                        <Typography sx={{ color: 'black', fontSize: '2.0vh', blackSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                            Prest Serviço
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box onClick={() => filtrarListaPessoasSaida('Hóspede (AppOne)')} sx={{ border: tipoVisitanteFiltro == 'Hóspede (AppOne)' ? '3px solid green' : '3px solid #000000', cursor: 'pointer', borderRadius: '10px', width: '80%', height: '27%', alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: ' center', margin: '5%', padding: "3px 0 1px 0" }}>
                <Box sx={{ width: '100%', height: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column', blackSpace: 'nowrap' }}>
                    <Typography sx={{ color: 'black', fontSize: '4.0vh', fontWeight: '600', height: '50%', alignItems: 'end', display: 'flex', justifyContent: 'center', padding: "3px 0 1px 0" }}>{metricas.hospede}</Typography>
                    <Box sx={{ width: '100%', height: '40%', display: 'flex', alignItems: 'center', overflow: 'hidden', justifyContent: 'center' }}>
                        <Typography sx={{ color: 'black', fontSize: '2.0vh', blackSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                            Hóspede
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {/* <Box sx={{ border: '3px solid green', borderRadius: '10px', width: '80%', height: '27%', alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: ' center', margin: '5%', padding: "3px 0 1px 0" }}>
                <Box sx={{ width: '100%', height: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column', blackSpace: 'nowrap' }}>
                    <Typography sx={{ color: 'black', fontSize: '4.0vh', fontWeight: '600', height: '50%', alignItems: 'end', display: 'flex', justifyContent: 'center' }}>35</Typography>
                    <Box sx={{ width: '100%', height: '40%', display: 'flex', alignItems: 'center', overflow: 'hidden', justifyContent: 'center' }}>
                        <Typography sx={{ color: 'black', fontSize: '2.0vh', blackSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        Pré-Autorizados
                        </Typography>
                    </Box>
                </Box>
            </Box> */}
        </Grid>
    )
}
export default Metricas
